import { render, staticRenderFns } from "./colAccionesBtnesProductos.vue?vue&type=template&id=59240c46&"
import script from "./colAccionesBtnesProductos.vue?vue&type=script&lang=js&"
export * from "./colAccionesBtnesProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports